import { Pipe, PipeTransform } from '@angular/core';
import { LocalizeService } from './localize.service';

@Pipe({
    name: 'localizeDate',
    pure: false,
    standalone: true
})
export class LocalizeDatePipe implements PipeTransform {

    constructor(
        private localizeService: LocalizeService,
    ) { }

    transform(value: string | number | Date, format: string = 'mediumDate'): string {
        return this.localizeService.transformDate(value, format);
    }

}
